import React from 'react';
import {COLORS} from "../../consts";
import classNames from "classnames";
import styles from "./styles/dropdown.module.scss";

class DropdownArrowDownProps {
  className: String;
  color: COLORS;
}

export const DropdownArrowDown = (props: DropdownArrowDownProps) => {
  const className = classNames(props.className || styles.arrow_down)
  const style = {borderTop: '5px solid ' + (props.color)}

  return <div className={className} style={style}/>
}
